import Button from './Button'
import DesktopSection from './DesktopSection'
import FeaturedCard from './FeaturedCard'
import MobileSection from './MobileSection'
import style from '../../styles/components/story-collection/story-collection'

const StoryCollection = ({ collection, loadMore, isLoading, hideButton }) => (
  <>
    {collection?.map((page, idx) => (
      <div key={idx} className='container'>
        <div className='story-collection'>
          {page?.[0] && <FeaturedCard story={page?.[0]} layout='three-column' type='primary' />}
          {page?.[1] && <FeaturedCard story={page?.[1]} layout='one-column' type='secondary' />}
          {page?.slice(2, 7).length !== 0 ? <DesktopSection stories={page?.slice(2, 7)} layout='three-column' type='long-card' /> : null}
          {page?.slice(7).length !== 0 ? <DesktopSection stories={page?.slice(7)} layout='one-column' type='overlap-card' /> : null}
          {page?.slice(2, 6).length !== 0 ? <MobileSection stories={page?.slice(2, 6)} type='long-card' /> : null}
          {page?.slice(6).length !== 0 ? <MobileSection stories={page?.slice(6)} type='overlap-card' /> : null}
        </div>
      </div>
    ))}
    {!hideButton && <Button label='Show More' loading={isLoading} onClick={loadMore} hideButton={hideButton} />}
    <style jsx>{style}</style>
  </>
)

export default StoryCollection
